import axiosInstance from "../../services/axiosInstance";
import * as S from "./style";
/**
 * Components
 */
import { useEffect, useState } from "react";
import Auth401 from "../../components/Error/Auth";
import Erro429 from "../../components/Error/Erro429";
import FilterButtonLine from "../../components/Filter/FilterButtonLine";
import Footer from "../../components/Footer";
import Loading from "../../components/Loading";
import Delete from "../../components/Modals/Delete";
import DeleteAll from "../../components/Modals/DeleteAll";
import Update from "../../components/Modals/Frame/Update";
import Details from "../../components/Modals/Order/Details";
import NoData from "../../components/NoData";
import PopMenu from "../../components/PopMenu";
import TitleMenu from "../../components/Title/TitleMenu";
import TopActionBar from "../../components/TopActionBar";
/**
 * hooks
 */
import { apiExport } from "../../hooks/apiExport";
import { useCheckbox } from "../../hooks/useCheckbox";
import useLoading from "../../hooks/useLoading";
import { useMultipleModal } from "../../hooks/useMultipleModal";
/**
 * utils
*/
import { CurrencyFormat } from "utils/CurrencyFormat";
import FormatarData from "utils/FormatData";
/**
 * Icons
 */
import { Circle } from "@phosphor-icons/react";
import { FiMoreVertical } from "react-icons/fi";

/**
 * Interfaces
*/
import { IOrder } from "Interfaces/IOrder";
import { IPage } from "Interfaces/IPage";

export default function Order() {
  const [frame, setFrame] = useState<IOrder[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const [selectAll, setSelectAll] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusUrl, setStatusUrl] = useState("");
  const [page, setCurrentPage] = useState<IPage>({
    id: 0,
    last_page: 0,
    current_page: 0,
    total: 0,
  });
  const { selectedIds, toggleCheckbox, setSelectedIds, CleanSelectIds } =
    useCheckbox();
  const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();
  const { isLoading, startLoading, stopLoading } = useLoading();

  const titleListPopMenu = ["Armação", "Fornecedor", "Grife", "Material"];
  const listHeaderTable = ["N° da Venda", "Data", "Cliente", "Status", "Mét. Pagamento", "Total", "Ações"];
  const tablePopMenu = ["Detalhes", "Excluir"];

  const [filters, setFilters] = useState({
    number_ata: "",
  });

  const fetchData = async (pageNumber = 1, perPage = 10) => {
    startLoading();
    try {
      let url = `/sale?page=${pageNumber}&per_page=${perPage}`;
      if (searchTerm) {
        url += `&search=${searchTerm}`;
      }
      if (statusUrl) {
        url += `&status=${statusUrl}`;

      }
      const response = await axiosInstance.get(url);
      const dataResponse = response.data.data;
      if (dataResponse.length > 0) {
        setFrame(dataResponse);
        setCurrentPage(response.data);
      } else {
        setFrame([]);
      }
    } catch (error: any) {
      if (error.status === 401) {
        toggleModalVisibility('auth');
      } else if (error.status === 429) {
        toggleModalVisibility('request429');
      }
      console.log("Error da Order: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    const debounceFetch = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(debounceFetch);
  }, [searchTerm, statusUrl]);

  const clickPopTable = (id: number) => {
    setOpenModalOptId(id);
    toggleModalVisibility("menu");
  };

  const handleSearchChange = (term: string) => {
    setSearchTerm(term);
    fetchData();
  };

  const handleCheckChange = (id: number) => {
    toggleCheckbox(id);
  };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      // Seleciona todos os IDs
      const newSelectedIds = new Set(frame.map((item) => item.id));
      setSelectedIds(newSelectedIds);
    } else {
      // Desmarca todos os IDs
      CleanSelectIds();
    }
  };

  const exportData = async () => {
    startLoading();
    try {
      await apiExport("/frame-export-pdf"); // Passe a URL diretamente
    } catch (error) {
      alert(`Erro ao exportar dados: ${error}`);
    } finally {
      stopLoading();
    }
  };

  const handleDeleteResponse = (status: number) => {
    if (status === 200) {
      setSelectedIds(new Set());
      setSelectAll(false);
    }
  };

  if (isOpenModal("auth")) {
    return (
      <Auth401 isOpen={isOpenModal("auth")} />
    )
  } else if (isOpenModal("request429")) {
    return (
      <Erro429 />
    )
  }

  return (
    <S.Container>
      <S.Content>
        <TitleMenu
          filterSearch={handleSearchChange}
          title="Registro de Vendas"
          subtitle="Gerencie as vendas do sistema"
          placeholderSearch="Código da Venda"
          listPopMenu={titleListPopMenu}
          fetchData={fetchData}
          exportButton={exportData}
          visibleButton={false}
        />

        <S.ContaintableButton>
          {/* Filtros */}

          <S.ContentFilterLine>
            <S.ContentButton>
              {selectedIds.length > 0 && (
                <TopActionBar
                  idSelecteds={selectedIds}
                  typeProduct="sale"
                  urlFilter={filters}
                  nameDeleteAll="sale-delete-multiple"
                  fetchData={fetchData}
                  handleDeleteResponse={handleDeleteResponse}
                  isPromo={false}
                />
              )}
            </S.ContentButton>

            <FilterButtonLine activeStatus={setStatusUrl} />
          </S.ContentFilterLine>

          {isLoading ? (
            <Loading />
          ) : (
            <S.ContentTable>
              <thead>
                <tr>
                  <th>
                    <S.CheckBox
                      type="checkbox"
                      id="deleteAll"
                      checked={selectAll}
                      onChange={(e) => handleSelectAll(e)}
                    />
                  </th>
                  {listHeaderTable.map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {frame.length > 0 ? (
                  frame.map((val, index) => (
                    <tr key={index}>
                      <td>
                        <S.CheckBox
                          onChange={() => handleCheckChange(val.id)}
                          type="checkbox"
                          checked={selectedIds.includes(val.id)}
                        />
                      </td>
                      <td>{val.number_ata || '-'}</td>
                      <td>{FormatarData(val.date_sale, 'default') || '-'}</td>
                      <td>{val.customer?.full_name || '-'}</td>
                      <td>
                        <div>
                          {
                            val.status === 'Pago' ? (
                              <S.Status isPay={true}>
                                <Circle size={8} weight="fill" />
                                <p>{val.status}</p>
                              </S.Status>
                            ) :
                              <S.Status isPay={false}>
                                <Circle size={8} weight="fill" />
                                <p>{val.status}</p>
                              </S.Status>
                          }
                        </div>
                      </td>
                      <td>{val.payment_method?.payment_method || '-'}</td>
                      <td>{CurrencyFormat(parseFloat(val.total_amount || "0"))}</td>
                      <td>
                        <S.ContentPopMenu>
                          <S.ButtonTable onClick={() => clickPopTable(val.id)}>
                            <FiMoreVertical />
                          </S.ButtonTable>
                        </S.ContentPopMenu>

                        {isOpenModal("menu") && openModalOptId === val.id && (
                          <div ref={(ref) => assignRef("menu", ref)}>
                            <PopMenu
                              listName={tablePopMenu}
                              onClickHandlers={[
                                () => toggleModalVisibility("details"),
                                () => toggleModalVisibility("delete"),
                              ]}
                            />
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoData />
                )}
              </tbody>
            </S.ContentTable>
          )}
        </S.ContaintableButton>
      </S.Content>

      {page && (
        <Footer
          fetchData={fetchData}
          currentPage={page.current_page}
          lastPage={page.last_page}
          allPerPage={page.total}
        />
      )}

      <Update
        isOpenModal={isOpenModal("update")}
        setModalClose={() => toggleModalVisibility("update")}
        selectedUrlId={openModalOptId}
        updateList={fetchData}
      />

      <Details
        isOpenModalDetails={isOpenModal("details")}
        setModalClose={() => toggleModalVisibility("details")}
        selectedUrlId={openModalOptId}
      />

      <Delete
        updateList={fetchData}
        endpoint="sale"
        selectedProductId={openModalOptId}
        isOpenModal={isOpenModal("delete")}
        setModalClose={() => toggleModalVisibility("delete")}
      />
    </S.Container>
  );
}
